import React from 'react';

export default function Pagination({ page, pages, total, onPageChange }) {
  if (pages <= 1) return null;

  const getPageNumbers = () => {
    const nums = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(pages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }
    for (let i = start; i <= end; i++) nums.push(i);
    return nums;
  };

  return (
    <div className="pagination">
      <span className="pagination-info">
        {total} cards total — Page {page} of {pages}
      </span>
      <div className="pagination-controls">
        <button
          disabled={page <= 1}
          onClick={() => onPageChange(1)}
          title="First page"
        >
          &laquo;
        </button>
        <button
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          title="Previous page"
        >
          &lsaquo;
        </button>
        {getPageNumbers().map((num) => (
          <button
            key={num}
            className={num === page ? 'active' : ''}
            onClick={() => onPageChange(num)}
          >
            {num}
          </button>
        ))}
        <button
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
          title="Next page"
        >
          &rsaquo;
        </button>
        <button
          disabled={page >= pages}
          onClick={() => onPageChange(pages)}
          title="Last page"
        >
          &raquo;
        </button>
      </div>
    </div>
  );
}
